export default {
    all: {
        Entrar:'11'
    }
}
